/* eslint-disable max-len */
import React from "react";
import HEAD from "next/head";
import { useSearchState } from "hooks/SearchContext";
import { useSearchResultsState } from "hooks/SearchResultsContext";
import {
    getCanonicalUrl,
    getSearchSeoTitle,
    getSearchSeoDescription,
    unSlugify
} from "utils/strings";

interface SEOParams {
    searchUrl: string;
}

export const Seo = (params: SEOParams): React.ReactElement => {
    const {
        company,
        keyword,
        location,
        filters
    } = useSearchState();
    const { searchUrl } = params;
    const canonical = getCanonicalUrl(searchUrl);
    const category = filters?.category.length === 1 ? filters?.category[0] : null;
    const { totalCount } = useSearchResultsState();
    const seoTitle = getSearchSeoTitle(
        location?.userSelectedLocation?.label,
        unSlugify(keyword?.userSelectedKeyword?.label),
        company?.userSelectedCompany?.label,
        category,
        totalCount
    );
    const title = `${seoTitle.suffix} | The Muse`;
    const description = getSearchSeoDescription(
        location?.userSelectedLocation?.label,
        unSlugify(keyword?.userSelectedKeyword?.label),
        company?.userSelectedCompany?.label,
        category,
        totalCount
    );

    return (
        <HEAD>
            <title>{title}</title>
            <meta key="viewport" name="viewport" content="width=device-width, initial-scale=1" />
            <meta key="robots" name="robots" content={canonical ? "index,follow" : "noindex,follow"} />
            <meta key="description" name="description" content={description} />
            <meta key="og:description" property="og:description" content={description} />
            <meta key="og:title" property="og:title" content={title} />
            <meta key="og:url" property="og:url" content={canonical} />
            <link key="canonical" rel="canonical" href={canonical} />
        </HEAD>
    );
};
